import { Text } from '@/components/text';
import { IconSymbol, IconSymbolName } from '@/components/ui/icon-symbol';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

export type BadgeProps = {
  label: string;
  color: string;
  iconName?: IconSymbolName;
  size?: number;
  style?: StyleProp<ViewStyle>;
};

export function Badge({ label, color, iconName, size = 12, style }: BadgeProps) {
  // Create a softened background by adding 15% opacity to the hex color
  // This works if color is a hex string (e.g., #RRGGBB)
  const backgroundColor = color.startsWith('#') ? `${color}26` : color;

  return (
    <View style={[styles.badge, { backgroundColor }, style]}>
      {iconName && <IconSymbol name={iconName} size={size} color={color} />}
      <Text style={[styles.text, { color, fontSize: size }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    alignSelf: 'flex-start',
  },
  text: {
    fontSize: 14,
    fontWeight: '700',
  },
});
